import React from "react";
import Button from "devextreme-react/button";
import { IMdaeButtonProps } from "./index";
import "./index.scss";
import $ from "jquery";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const MdaeButton: React.FC<IMdaeButtonProps> = (props) => {
  const onFocusIn = (e) => {
    if (props.role === "primary") {
      $(e.component.element()).addClass("mdae-focused-primary-button");
    } else if (props.role === "secondary") {
      $(e.component.element()).addClass("mdae-focused-secondary-button");
    }
  };
  const onFocusOut = (e) => {
    $(e.component.element()).removeClass("mdae-focused-primary-button");
    $(e.component.element()).removeClass("mdae-focused-secondary-button");
  };
  const bindFocusInOutEvent = (e) => {
    $(e.component.element()).on("focusin", () => {
      onFocusIn(e);
    });
    $(e.component.element()).on("focusout", () => {
      onFocusOut(e);
    });
  };
  const hintText = props?.elementAttr?.title;
  return props.role === "action" ? (
    <div className={"sys-mdae-action-btn"}>
      <Button onClick={props.onClick} hint={hintText} icon={props.icon} {...props} >
        <div className={"action-btn-content-container"}>
          {props.mdaeIcon && (
            <div className={"icon"}>
              <props.mdaeIcon />
            </div>
          )}
          {props.fontAwesomeIcon && (
            <div className={"icon"}>
              <FontAwesomeIcon icon={props.fontAwesomeIcon} />
            </div>
          )}
          <div className={"text"}>{props.text}</div>
        </div>
      </Button>
    </div>
  ) : props.role === "primary" ? (
    <Button
      hint={hintText}
      {...props}
      onInitialized={(e) => {
        if (typeof props.onInitialized === "function") props.onInitialized(e);
        bindFocusInOutEvent(e);
      }}
      className={"mdae-primary-button " + props.className}
    >
      {props.children}
    </Button>
  ) : props.role === "secondary" ? (
    <Button
      className={"mdae-secondary-button"}
      hint={hintText}
      {...props}
      onInitialized={(e) => {
        if (typeof props.onInitialized === "function") props.onInitialized(e);
        bindFocusInOutEvent(e);
      }}
    >
      {props.children}
    </Button>
  ) : (
    props.role === "dxButton" && <Button  hint={hintText} {...props}>{props.children}</Button>
  );
};
export default MdaeButton;
